/* LF-4: gör en citations-post öppningsbar i DocumentPreviewModal.
   Prioritet för download_url:
     1. highlight_url (gul markering på rätt sida) om posten har den
     2. /projects/{project_id}/documents/{document_id}/download när project_id finns
     3. download_url från backend om den skickats med
   Saknas alla tre (gamla poster utan projekt) returneras null och
   källan visas utan länk. */
import { API_URL } from "../../api";
import { withTenantSlug } from "./chatData";

function toAbsolute(url) {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  return `${API_URL}${url.startsWith("/") ? url : `/${url}`}`;
}

export function citationPage(cite) {
  const n = Number(cite?.page);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function citationDocumentName(cite, fallbackLabel) {
  return cite?.document_name || cite?.filename || fallbackLabel || `Dokument ${cite?.document_id}`;
}

export function citationPreviewDoc(cite, fallbackLabel) {
  const documentId = cite?.document_id;
  if (!documentId && cite?.highlight_url) {
    // Kunskapsbasens standarder (AMA m.fl.): PDF-syskon med sida + gul markering
    const rel = cite.relative_path || cite.path || "";
    const namn = (rel.split("/").pop() || fallbackLabel || "Standard").replace(/\.md$/i, ".pdf");
    return {
      id: rel || namn,
      name: namn,
      page: citationPage(cite),
      download_url: withTenantSlug(toAbsolute(cite.highlight_url)),
    };
  }
  if (!documentId) return null;
  let url = "";
  if (cite.highlight_url) {
    url = toAbsolute(cite.highlight_url);
  } else if (cite.project_id) {
    url = `${API_URL}/projects/${cite.project_id}/documents/${encodeURIComponent(String(documentId))}/download`;
  } else if (cite.download_url) {
    url = toAbsolute(cite.download_url);
  }
  if (!url) return null;
  return {
    id: documentId,
    name: citationDocumentName(cite, fallbackLabel),
    page: citationPage(cite),
    download_url: withTenantSlug(url),
  };
}
